<!-- Contacts model -->
<div class="modal-header">
    <h5 class="modal-title">Ajouter une Action</h5>
    <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body p-3">
    <div class="text-left">
        <form>
            <div class="text-end mt-3">
                <button (click)="close()" type="button" class="btn btn-light ms-1">
                    <i class="pi pi-times" style="color: #212529"></i> Annuler
                </button>&nbsp;
                <button (click)="EditAction()" type="submit" class="btn btn-success">
                    <i class="pi pi-save" style="color: white"></i> Enregistrer
                </button>
            </div>

            <!-- Première ligne -->
            <div class="row mb-3">
              <div class="form-group col-md-6">
                    <label for="programme_id">Programme</label>
                    <select name="programme_id" id="programme_id" class="form-select" (change)="onProgrammeChange($event);onSelectProgramme()" [(ngModel)]="item.programme_id">
                        <option> Sélectionner un programme</option>
                        <option *ngFor="let prog of programmeData" [ngValue]="prog"> {{prog.libelle}}</option>
                    </select>
                </div>
                <div class="form-group col-md-2">
                    <label for="code">Code</label>
                    <input [(ngModel)]="item.code" name="code" type="text" class="form-control" id="code">
                </div>
                <div class="form-group col-md-4">
                    <label for="libelle">Libellé</label>
                    <input [(ngModel)]="item.libelle" name="libelle" type="text" class="form-control" id="libelle">
                </div>



            </div>

            <!-- Deuxième ligne -->
            <div class="row mb-3">
                    <div class="form-group col-md-4">
                    <label for="resultat">Résultat</label>
                    <select [(ngModel)]="item.resultat" type="text" name="resultat" class="form-select" id="resultat">
                        <option value="">Sélectionner un résultat</option>
                        <option *ngFor="let item of resultatItems" [value]="item.id">{{item.libelle}}</option>
                    </select>
                </div>
                <div class="form-group col-md-4">
                    <label for="poids">Poids</label>
                    <input [(ngModel)]="item.poids" type="number" name="poids" class="form-control" id="poids">
                </div>
                <div class="form-group col-md-4">
                    <label for="duree">Durée</label>
                    <input [(ngModel)]="item.duree" type="number" name="duree" class="form-control" id="duree">
                </div>

            </div>

            <!-- Troisième ligne -->
            <div class="row mb-3">
                <div class="form-group col-md-4">
                    <label for="date_debut">Date Début</label>
                    <input [(ngModel)]="item.date_debut" type="date" name="date_debut" class="form-control"
                        id="date_debut">
                </div>
                <div class="form-group col-md-4">
                    <label for="date_fin">Date Fin</label>
                    <input [(ngModel)]="item.date_fin" type="date" name="date_fin" class="form-control" id="date_fin">
                </div>



                <div class="form-group col-md-4">
                    <label for="agence_mo">Agence MO</label>
                    <input name="agence_mo" id="agence_mo" class="form-control" [(ngModel)]="item.agence_mo">

                </div>

            </div>

            <!-- Quatrième ligne -->
            <div class="row mb-3">
                <div class="form-group col-md-4">
                    <label for="agence_mo">Agence CO</label>
                    <input name="agence_mo" id="agence_co" class="form-control" [(ngModel)]="item.agence_coord">

                </div>
                <div class="form-group col-md-4">
                    <label for="mo">MO</label>
                    <input [(ngModel)]="item.mo" type="text" name="mo" class="form-control" id="mo">
                </div>
                <div class="form-group col-md-4">
                    <label for="zone_intervention">Zone d'intervention</label>
                    <input [(ngModel)]="item.zone_intervention" type="text" name="zone_intervention"
                        class="form-control" id="zone_intervention">
                </div>

            </div>

            <!-- Cinquième ligne -->
            <div class="row mb-3">
             <div class="form-group col-md-4">
                    <label for="montant">Montant</label>
                    <input [(ngModel)]="item.montant" type="number" name="montant" class="form-control" id="montant">
                </div>

                <div class="form-group col-md-4">
                    <label for="mt_fadec">Montant FADEC</label>
                    <input [(ngModel)]="item.mt_fadec" type="number" name="mt_fadec" class="form-control" id="mt_fadec">
                </div>
                <div class="form-group col-md-4">
                    <label for="mt_fadec_non_affecte">FADEC Non Affecté</label>
                    <input [(ngModel)]="item.mt_fadec_non_affecte" type="number" name="mt_fadec_non_affecte"
                        class="form-control" id="mt_fadec_non_affecte">
                </div>

            </div>

            <!-- Sixième ligne -->
            <div class="row mb-3">
                <div class="form-group col-md-4">
                    <label for="mt_mairie">Montant Mairie</label>
                    <input [(ngModel)]="item.mt_mairie" type="number" name="mt_mairie" class="form-control"
                        id="mt_mairie">
                </div>
                <div class="form-group col-md-4">
                    <label for="mt_mairie">Montant Partenaire</label>
                    <input [(ngModel)]="item.mt_partenaire" type="number" name="mt_mairie" class="form-control"
                        id="mt_mairie">
                </div>
                <div class="form-group col-md-4">
                    <label for="objectif_specifique">Objectif Spécifique</label>
                    <textarea [(ngModel)]="item.objectif_specifique" name="objectif_specifique" class="form-control"
                        id="objectif_specifique"></textarea>
                </div>

            </div>

            <div class="row mb-3">
                <div class="form-group col-md-4">
                    <label for="objectif_global">Objectif Global</label>
                    <textarea [(ngModel)]="item.objectif_global" name="objectif_global" class="form-control"
                        id="objectif_global"></textarea>
                </div>
                <div class="form-group col-md-4">
                    <label for="observations">Observations</label>
                    <textarea [(ngModel)]="item.observations" name="observations" class="form-control"
                        id="observations"></textarea>
                </div>
                <div class="form-group col-md-4">
                    <label for="perspectives">Perspectives</label>
                    <textarea [(ngModel)]="item.perspectives" name="perspectives" class="form-control"
                        id="perspectives"></textarea>
                </div>
                <div class="form-group col-md-4">
                    <label for="personnes_a_contacter">Personnes à Contacter</label>
                    <textarea [(ngModel)]="item.personnes_a_contacter" name="personnes_a_contacter" class="form-control"
                        id="personnes_a_contacter"></textarea>
                </div>
            </div>

        </form>
    </div>
</div>
